import React from 'react';
import { useSelector } from 'react-redux';

const Actions = ({ onDelete = null, onArchive, onAdd = null }) => {
    const briefing = useSelector((state) => state.briefing.line);

    return (
        <div className='actions-cell'>
            <button
                className="btn-xs action-btn btn-archive"
                onClick={onArchive}
                title="Archive"
                disabled={briefing === "Old Briefings"}
            >
                <i className="fa fa-archive"></i>
            </button>

            {onDelete && (
                <button
                    className="btn-xs action-btn btn-delete"
                    onClick={onDelete}
                    title="Delete"
                    disabled={briefing === "Old Briefings"}
                >
                    <i className="fa fa-trash"></i>
                </button>
            )}

            {onAdd && (
                <button
                    className="btn-xs action-btn btn-add"
                    onClick={onAdd}
                    title="Add Subcontext"
                    disabled={briefing === "Old Briefings"}
                >
                    <i className="fa fa-plus"></i>
                </button>
            )}
        </div>
    );
};

export default Actions;
